module.exports = __webpack_public_path__ + "static/jade2-45b1d3bb108c6d4bd4d4a873383a2e6c.png";